angular.module('unergie.main')
.controller('bypassReadingsWarningModalCtrl', ($scope, $uibModalInstance, bulk_purchase) => {
    $scope.bulk_purchase = bulk_purchase
    $scope.close = $uibModalInstance.dismiss
})
